<template>
    <div class="workBench_wrap">
        <div class="grid_wrap">
            <div
                v-for="(item, index) in gridData"
                :key="index"
                :class="['item_grid_list', { 'is-resize': item.isDrag }]"
                :style="{ width: item.width, height: item.height + 'px' }"
                @mousedown="onStartResize($event, index, item.isDrag)"
                @mousemove="onResize($event, index, item.isDrag)"
                @mouseup="onStopResize"
            >
                <div class="item_grid_list_wrap">
                    <p class="item_grid_list_title">{{ item.title }}</p>
                    <div class="item_grid_list_content">
                        <template v-if="item.type == 'application'">
                            <ul class="application_wrap">
                                <li v-for="(applicationItem, applicationIndex) in item.list" class="application_item">
                                    <div class="application_item_icon"></div>
                                    <div class="application_item_content">
                                        <span>小标题</span>
                                        <span>说明文本</span>
                                    </div>
                                </li>
                            </ul>
                        </template>
                        <div v-else class="item_grid_content_wrap"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="edit_tip_box" @click="handleClickDialogShow">
            <img src="https://download.hecoos.com/enlightv/2024-49/510ca605f0d731acee1529ef527d2260.png" alt="" />
            <span>编辑首页</span>
        </div>
        <el-drawer
            title=""
            :visible.sync="editDialog"
            direction="rtl"
            :show-close="false"
            :size="663"
            :before-close="handleDialogClose"
            class="edit_drawer_wrapper"
        >
            <div slot="title" class="edit_drawer_title">
                <span class="edit_drawer_close" @click="handleDialogClose">
                    <i class="el-icon-close"></i>
                </span>
                <span class="edit_drawer_confirm">确定</span>
            </div>
            <div class="edit_drawer_card">
                <div
                    class="edit_drawer_card_item"
                    v-for="(item, index) in editGridData"
                    :key="index"
                    :style="{ width: item.width, height: item.height + 'px' }"
                >
                    <div class="edit_drawer_card_item_wrap">
                        <span>{{ item.title }}</span>
                        <span class="edit_drawer_card_item_delete" @click="handleClickCardDelete(index)"
                            ><i class="iconfont icon-jianqu"></i
                        ></span>
                    </div>
                </div>
            </div>
            <div class="edit_drawer_search">
                <el-input v-model="searchForm.keyword" clearable placeholder="搜索组件">
                    <i slot="prefix" class="iconfont icon-sousuo"></i>
                </el-input>
            </div>
            <div class="edit_drawer_list">
                <div class="set_popup_card" v-for="(cardItem, cardIndex) in allApplications" :key="cardIndex">
                    <p class="set_item_title">{{ cardItem.title }}</p>
                    <ul>
                        <li v-for="(item, index) in cardItem.children" :key="index">
                            <span class="icon_wrap"
                                ><i :class="['iconfont', item.icon]"></i
                                ><span class="operate_icon add_icon" @click="handleClickAddItem(cardIndex, item, index)"
                                    ><i class="iconfont icon-a-tianjiamiaobian"></i></span
                            ></span>
                            <span>{{ item.title }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
export default {
    name: "WorkBench",
    data() {
        return {
            gridData: [
                {
                    width: "80%",
                    height: 210,
                    title: "应用",
                    type: "application",
                    list: new Array(20),
                },
                {
                    width: "20%",
                    height: 210,
                    title: "卡片",
                },
                {
                    width: "40%",
                    height: 421,
                    title: "数据",
                },
                {
                    width: "40%",
                    height: 421,
                    title: "图表",
                },
                {
                    width: "20%",
                    height: 421,
                    title: "数据1",
                },
                {
                    width: "100%",
                    height: 200,
                    title: "数据4",
                    isDrag: true,
                },
                {
                    width: "40%",
                    height: 210,
                    title: "数据2",
                },
                {
                    width: "60%",
                    height: 210,
                    title: "数据3",
                },
            ], // 选中行的格子数据
            editDialog: false,
            editGridData: [
                {
                    width: "80%",
                    height: 107,
                    title: "卡片1",
                },
                {
                    width: "20%",
                    height: 107,
                    title: "卡片2",
                },
                {
                    width: "30%",
                    height: 107,
                    title: "卡片3",
                },
                {
                    width: "50%",
                    height: 212,
                    title: "卡片4",
                },
                {
                    width: "20%",
                    height: 212,
                    title: "卡片5",
                },
                {
                    width: "30%",
                    height: 212,
                    title: "卡片6",
                },
                {
                    width: "50%",
                    height: 107,
                    title: "卡片7",
                },
                {
                    width: "50%",
                    height: 107,
                    title: "卡片8",
                },
            ],
            searchForm: {
                keyword: "",
            },
            allApplications: [
                {
                    title: "协同办公",
                    children: [
                        { title: "日程表", name: "", path: "", icon: "" },
                        { title: "通讯录", name: "", path: "", icon: "" },
                        { title: "系统公告", name: "", path: "", icon: "" },
                        { title: "勤务表", name: "", path: "", icon: "" },
                        { title: "报销申请", name: "", path: "", icon: "" },
                    ],
                },
                {
                    title: "客户管理",
                    children: [
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户档案", name: "", path: "", icon: "" },
                        { title: "商机管理", name: "", path: "", icon: "" },
                        { title: "订单管理", name: "", path: "", icon: "" },
                        { title: "开票申请", name: "", path: "", icon: "" },
                        { title: "退款申请", name: "", path: "", icon: "" },
                        { title: "提成申请", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                        { title: "客户公海", name: "", path: "", icon: "" },
                    ],
                },
            ], // 全部应用
            isResizing: false, // 是否能改变大小
            initialX: 0,
            initialY: 0,
            initialWidth: 0, // 初始宽度
            initialHeight: 0, // 初始高度
        };
    },
    methods: {
        onStartResize(event, index, isDrag) {
            if (!isDrag) return;
            this.isResizing = true;
            this.initialX = event.clientX || event.touches.clientX;
            this.initialY = event.clientY || event.touches.clientY;
            // this.initialWidth = this.elementWidth;
            this.initialHeight = this.gridData[index].height;
        },
        onResize(event, index, isDrag) {
            if (!isDrag) return;
            if (!this.isResizing) return;

            const currentX = event.clientX || event.touches.clientX;
            const currentY = event.clientY || event.touches.clientY;

            const deltaX = currentX - this.initialX;
            const deltaY = currentY - this.initialY;

            // this.gridData[index].width = Math.max(this.initialWidth + deltaX, 80); // 最小宽度为50px
            this.gridData[index].height = Math.max(this.initialHeight + deltaY, 80); // 最小高度为50px
        },
        onStopResize() {
            this.isResizing = false;
        },
        // 删除卡片
        handleClickCardDelete(index) {
            this.editGridData.splice(index, 1);
        },
        handleClickDialogShow() {
            this.editDialog = true;
        },
        handleDialogClose() {
            this.editDialog = false;
        },
        // 添加
        handleClickAddItem() {},
    },
};
</script>
<style lang="scss" scoped>
.workBench_wrap {
    width: 100%;
    height: 100%;
    background: rgba(247, 248, 250, 1);
    .grid_wrap {
        width: 100%;
        height: 100%;
        padding: 8px;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
    }
    .item_grid_list {
        user-select: none;
        padding: 8px;
        &.is-resize {
            cursor: s-resize;
        }
        .item_grid_list_wrap {
            height: 100%;
            border-radius: 8px;
            background: rgba(255, 255, 255, 1);
            display: flex;
            flex-direction: column;
        }
        .item_grid_list_title {
            padding: 10px;
            font-size: 14px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(0, 0, 0, 1);
        }
        .item_grid_list_content {
            flex: 1;
            overflow-y: auto;
        }
        .application_wrap {
            display: flex;
            flex-wrap: wrap;
            padding: 0 10px;
            .application_item {
                padding-left: 6px;
                margin-bottom: 8px;
                width: 165px;
                height: 42px;
                display: flex;
                gap: 10px;
                .application_item_icon {
                    flex-shrink: 0;
                    width: 42px;
                    height: 42px;
                    border-radius: 6px;
                    background: rgba(204, 204, 204, 1);
                }
                .application_item_content {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    span:nth-child(1) {
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(51, 51, 51, 1);
                    }
                    span:nth-child(2) {
                        margin-top: 2px;
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 18px;
                        color: rgba(153, 153, 153, 1);
                    }
                }
            }
        }
        .item_grid_content_wrap {
            margin: 10px 16px 0;
            height: calc(100% - 20px);
            // background: rgba(204, 204, 204, 1);
        }
    }
}
.edit_tip_box {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 26px;
    height: 95px;
    opacity: 1;
    border-radius: 7.5px 0px 0px 7.5px;
    background: rgba(61, 75, 89, 1);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    & > img {
        width: 11px;
        height: 10px;
    }
    span {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 5px;
        line-height: 18px;
        color: rgba(255, 255, 255, 1);
        writing-mode: vertical-lr;
    }
}
.edit_drawer_wrapper {
    ::v-deep {
        .el-drawer.rtl {
            top: 38px;
            right: 4px;
            bottom: 4px;
            height: auto;
            border-radius: 8px;
        }
        .el-drawer__header {
            padding: 0;
            margin-bottom: 0;
        }
    }
    .edit_drawer_title {
        padding: 10px 16px;
        display: flex;
        justify-content: space-between;
        & > span {
            width: 36px;
            height: 22px;
            text-align: center;
            line-height: 22px;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
            cursor: pointer;
            .el-icon-close {
                color: rgba(102, 102, 102, 1);
            }
        }
        .edit_drawer_confirm {
            font-size: 14px;
            font-weight: 700;
            letter-spacing: 0px;
            color: rgba(42, 130, 228, 1);
        }
    }
    .edit_drawer_card {
        padding: 2px 12px;
        display: flex;
        flex-wrap: wrap;
        .edit_drawer_card_item {
            position: relative;
            padding: 5px;
            .edit_drawer_card_item_wrap {
                width: 100%;
                height: 100%;
                background-color: #ffffff;
                box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 24px;
                color: rgba(51, 51, 51, 1);
                .edit_drawer_card_item_delete {
                    position: absolute;
                    top: -7px;
                    right: -5px;
                    width: 14px;
                    height: 14px;
                    color: rgba(191, 191, 191, 1);
                    cursor: pointer;
                }
            }
        }
    }
    .edit_drawer_search {
        padding: 12px 16px 0;
        .el-input {
            ::v-deep {
                .el-input__inner {
                    height: 32px;
                    border-radius: 6px;
                    background: rgba(243, 243, 243, 1);
                }
                .el-input__prefix {
                    line-height: 32px;
                    color: rgba(51, 51, 51, 1);
                }
            }
        }
    }
    .edit_drawer_list {
        padding: 10px 0;
    }
    .set_popup_card {
        margin-bottom: 16px;
        .set_item_title {
            margin: 0 16px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(0, 0, 0, 1);
            padding-bottom: 5px;
            position: relative;
            &::after {
                content: "";
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 1px;
                border-radius: 1px;
                background-color: rgba(204, 204, 204, 1);
            }
        }
        ul {
            display: flex;
            flex-wrap: wrap;
            li {
                width: 110px;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 18px;
                .icon_wrap {
                    width: 42px;
                    height: 42px;
                    opacity: 1;
                    border-radius: 6px;
                    background: rgba(204, 204, 204, 1);
                    position: relative;
                    .operate_icon {
                        position: absolute;
                        top: -7px;
                        right: -7px;
                        width: 14px;
                        height: 14px;
                        cursor: pointer;
                        .iconfont {
                            font-size: 14px;
                        }
                    }
                    .add_icon {
                        color: rgba(42, 130, 228, 1);
                    }
                    .delete_icon {
                        color: rgba(204, 204, 204, 1);
                    }
                }
                & > span {
                    margin-top: 4px;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                }
            }
        }
    }
}
</style>
